export const hasDialogSupport = () => typeof HTMLDialogElement === 'function';
